import type { CoreOption, default as Option, LazyOption } from '../store/schema/Option';
import type OptionSubCategory from '../store/schema/OptionSubCategory';

export type FullOption = Pick<Option, keyof CoreOption | 'fullOptionFormSettings'>;

export function tryLoadAllFullOptionsSync(subcategory: OptionSubCategory): FullOption[] {
    const loadedOptions: FullOption[] = subcategory.options
        .filter(option => isFullOption(option) || isLazyFullOption(option))
        .map(
            option =>
                (isFullOption(option)
                    ? option
                    : {
                          ...option,
                          fullOptionFormSettings: option.tryImportFullOptionFormSettingsSync!(),
                      }) as FullOption
        );

    // If some options haven't yet loaded, return `null`
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (23,5): Type 'FullOption[] | null' is not assignable to type 'FullOption[]'.
    // @ts-expect-error
    return loadedOptions.some(({ fullOptionFormSettings }) => !fullOptionFormSettings)
        ? null
        : loadedOptions;
}

function isFullOption(option: any): option is Option {
    return option['fullOptionFormSettings'] ?? false;
}

function isLazyFullOption(option: any): option is LazyOption {
    return option['tryImportFullOptionFormSettingsSync'] ?? false;
}
